import LectureWorkloadSummaryStatusItemModelBase from '../_generated/modelBases/lecture-workload-summary-status-item-model-base';

export default class LectureWorkloadSummaryStatusItemModel extends LectureWorkloadSummaryStatusItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
